import { Backdrop } from '@sdk/components/ui/InfoModal/infoInnerModal.styles';
import gettext from '@sdk/lang/gettext';
import DisplayText from '@sdk/components/ui/DisplayText';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Href from '@sdk/components/ui/Href';
import Modal from '@sdk/components/ui/modal/Modal';

import CheckmarkGray from '@web/assets/svg/UI/checkmark-gray.svg';
import BodyPortal from '@web/components/BodyPortal';
import { SubscriptionFeatureList } from '@web/account/components/SubscriptionFeatureList/SubscriptionFeatureList';
import {
  SCHEDULING_LITE_FEATURE_LIST,
  SCHEDULING_PRO_FEATURE_LIST,
} from '@web/account/components/ToastBillingPlansModal/toastBillingPlansModal.consts';

import {
  Header,
  InnerContainer,
  Main,
  RecommendedBadge,
  Sidebar,
  SubscriptionFooter,
} from './toastBillingPlansModal.styles';

type Props = {
  dismiss: VoidFunction;
};

export const ToastBillingPlansModal = (props: Props) => {
  return (
    <BodyPortal>
      <Modal isVisible onDismiss={props.dismiss}>
        <InnerContainer>
          <Header>
            <DisplayText fontSize={18} themeColor={ThemeColorType.primary} bold>
              {gettext('Get more out of Sling for your business!')}
            </DisplayText>
            <br />
            <DisplayText fontSize={14} themeColor={ThemeColorType.gray}>
              {gettext('Upgrade your subscription to gain access to more features.')}
            </DisplayText>
          </Header>
          <Sidebar>
            <SubscriptionFeatureList
              title={gettext('Scheduling Lite')}
              subtitle={gettext('Schedule faster, communicate better, and get things done!')}
              featureList={SCHEDULING_LITE_FEATURE_LIST}
              footerText={gettext('Plus many others')}
            />
            <SubscriptionFooter>
              <CheckmarkGray />
              <DisplayText fontSize={14} fontWeight="bold" themeColor={ThemeColorType.gray}>
                {gettext('Current plan')}
              </DisplayText>
            </SubscriptionFooter>
          </Sidebar>
          <Main>
            <div>
              <RecommendedBadge label={gettext('recommended')} />
              <SubscriptionFeatureList
                title={gettext('Scheduling Pro')}
                subtitle={gettext('Understand your labor data, and run your business efficiently!')}
                featureList={SCHEDULING_PRO_FEATURE_LIST}
                footerText={gettext('Plus everything in Scheduling Lite')}
              />
            </div>

            <SubscriptionFooter>
              <Href
                fontSize={14}
                semiBold
                themeColor={ThemeColorType.primary}
                href="/account/billing">
                {gettext('Learn more about Scheduling Pro >')}
              </Href>
            </SubscriptionFooter>
          </Main>
        </InnerContainer>

        <Backdrop onClick={props.dismiss} />
      </Modal>
    </BodyPortal>
  );
};
